import { Stack } from '@chakra-ui/react';
import Header from '@components/typography/Header';

const TextSection = ({ title = null, children }) => (
  <section>
    <Stack spacing={6}>
      {title && <Header as="h2">{title}</Header>}
      {children}
    </Stack>
  </section>
);

export default TextSection;
